export interface RowFormValue<Row, Column> {
  enabled: boolean;
  column;
}

export interface ColumnDetail<Column> {
  column: Column;
  label: string;
  tooltip?: string;
}

export interface RowDetail<Row, Column> {
  key: Row;
  label: string;
  availableColumns?: Column[]; // by default, all columns are available
  tooltip?: string;
  hidden?: boolean;
}

export type ComplexSelectionFormValue<Row extends string, Column> = {
  [key in Row]?: RowFormValue<Row, Column>;
};

export enum ComplexSelectionGroupEvent {
  ROW_CHECKBOX_CHANGE = 'row-checkbox-change',
  ROW_VALUE_CHANGE = 'row-value-change',
}

export enum SelectionType {
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
}
